// Component names for error messages
export const ROOT_NAME = "FileUpload";
export const DROPZONE_NAME = "FileUploadDropzone";
export const TRIGGER_NAME = "FileUploadTrigger";
export const LIST_NAME = "FileUploadList";
export const ITEM_NAME = "FileUploadItem";
export const ITEM_PREVIEW_NAME = "FileUploadItemPreview";
export const ITEM_METADATA_NAME = "FileUploadItemMetadata";
export const ITEM_PROGRESS_NAME = "FileUploadItemProgress";
export const ITEM_DELETE_NAME = "FileUploadItemDelete";
export const CLEAR_NAME = "FileUploadClear";

// File extension constants
export const TEXT_EXTENSIONS = ["txt", "md", "rtf", "pdf"];
export const CODE_EXTENSIONS = [
  "html",
  "css",
  "js",
  "jsx",
  "ts",
  "tsx",
  "json",
  "xml",
  "php",
  "py",
  "rb",
  "java",
  "c",
  "cpp",
  "cs",
];
export const ARCHIVE_EXTENSIONS = ["zip", "rar", "7z", "tar", "gz", "bz2"];
export const EXECUTABLE_EXTENSIONS = ["exe", "msi", "app", "apk", "deb", "rpm"];

